import { render, staticRenderFns } from "./BrandSubscriptionHistory.vue?vue&type=template&id=436dea18&scoped=true&"
import script from "./BrandSubscriptionHistory.vue?vue&type=script&lang=ts&"
export * from "./BrandSubscriptionHistory.vue?vue&type=script&lang=ts&"
import style0 from "./BrandSubscriptionHistory.vue?vue&type=style&index=0&id=436dea18&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "436dea18",
  null
  
)

export default component.exports